import { modelsProxyUrl } from "../../../../../API/axiosInstance";

// ─── Design Tokens ────────────────────────────────────────────────────────────

export const SESSION_DETAILS_ENDPOINT = "/session-details";
export const SESSION_DETAILS_URL = modelsProxyUrl(SESSION_DETAILS_ENDPOINT);
export const POST_CRAWL_REFRESH_DELAY_MS = 5000;

export const COLORS = {
  primary: "#4F46E5",
  primaryLight: "#EEF2FF",
  primaryMid: "#C7D2FE",
  primaryDark: "#3730A3",
  surface: "#FFFFFF",
  border: "#E2E8F0",
  borderFocus: "#818CF8",
  text: "#1E293B",
  textMuted: "#64748B",
  textLight: "#94A3B8",
  success: "#10B981",
  shadowMd:
    "0 4px 6px -1px rgba(15,23,42,0.07), 0 2px 4px -2px rgba(15,23,42,0.05)",
  shadowLg:
    "0 10px 25px -3px rgba(79,70,229,0.12), 0 4px 6px -4px rgba(79,70,229,0.06)",
};

export const FONT = "'Host Grotesk', sans-serif";

// ─── MUI Style Objects ───────────────────────────────────────────────────────

export const inputBaseSx = {
  backgroundColor: COLORS.surface,
  fontFamily: FONT,
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    height: "44px",
    fontFamily: FONT,
    fontSize: "14px",
    transition: "all 0.2s ease",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.primaryMid,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.borderFocus,
      borderWidth: "1.5px",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: FONT,
    fontSize: "16px",
    color: COLORS.textMuted,
    "&.Mui-focused": { color: COLORS.primary },
  },
};

export const selectSx = {
  ".MuiOutlinedInput-root": {
    borderRadius: "10px",
    height: "44px",
    fontFamily: FONT,
    fontSize: "14px",
    transition: "all 0.2s ease",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.primaryMid,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.borderFocus,
      borderWidth: "1.5px",
    },
  },
  ".MuiSelect-select": { paddingTop: "10px", paddingBottom: "10px" },
  ".MuiInputLabel-root": {
    fontFamily: FONT,
    fontSize: "16px",
    color: COLORS.textMuted,
    "&.Mui-focused": { color: COLORS.primary },
  },
};

export const menuItemSx = {
  fontFamily: FONT,
  fontSize: "13px",
  padding: "10px 16px",
  borderRadius: "6px",
  margin: "2px 6px",
  "&:hover": { backgroundColor: COLORS.primaryLight },
  "&.Mui-selected": {
    backgroundColor: COLORS.primaryLight,
    fontWeight: 600,
    "&:hover": { backgroundColor: COLORS.primaryMid },
  },
};

export const menuPaperStyle = {
  maxHeight: 220,
  borderRadius: "10px",
  boxShadow: COLORS.shadowLg,
  border: `1px solid ${COLORS.border}`,
};

// ─── SSE Badge Config ────────────────────────────────────────────────────────

export const CONN_UI = {
  idle: {
    dot: COLORS.textLight,
    pulse: false,
    label: "Idle",
    bg: "rgba(100,116,139,0.08)",
    border: COLORS.border,
    text: COLORS.textMuted,
  },
  connecting: {
    dot: "#F59E0B",
    pulse: true,
    label: "Connecting…",
    bg: "rgba(245,158,11,0.08)",
    border: "rgba(245,158,11,0.3)",
    text: "#D97706",
  },
  live: {
    dot: COLORS.success,
    pulse: true,
    label: "Live",
    bg: "rgba(16,185,129,0.08)",
    border: "rgba(16,185,129,0.3)",
    text: COLORS.success,
  },
  error: {
    dot: "#EF4444",
    pulse: false,
    label: "Disconnected",
    bg: "rgba(239,68,68,0.08)",
    border: "rgba(239,68,68,0.3)",
    text: "#DC2626",
  },
};

// ─── Platform Config ─────────────────────────────────────────────────────────

export const PLATFORMS = [
  "All",
  "Twitter",
  "YouTube",
  "Reddit",
  "Quora",
  "Pinterest",
  "Facebook",
  "Instagram",
  "Threads",
];

export const PLATFORM_SORT_OPTIONS = {
  Twitter: ["Top", "Latest"],
  YouTube: ["Relevance", "Popularity", "Top"],
};

export const CRAWL_MESSAGES = {
  twitter: "Crawling Twitter — results will appear shortly",
  youtube: "Crawling YouTube — results will appear shortly",
  facebook: "Crawling Facebook — results will appear shortly",
  threads: "Crawling Threads — results will appear shortly",
  reddit: "Crawling Reddit — results will appear shortly",
  quora: "Crawling Quora — results will appear shortly",
  pinterest: "Crawling Pinterest — results will appear shortly",
  instagram: "Crawling Instagram — results will appear shortly",
};

export const TYPE_MAP = {
  "Section Analysis": "section",
  "Sentiment Analysis": "sentiment",
};

// ─── Toast Styles ────────────────────────────────────────────────────────────

export const TOAST_STYLE = {
  fontFamily: "'Host Grotesk', sans-serif",
  fontSize: "13px",
  fontWeight: 500,
  borderRadius: "12px",
  padding: "14px 18px",
  boxShadow:
    "0 8px 32px -4px rgba(0,0,0,0.12), 0 2px 8px -2px rgba(0,0,0,0.06)",
  border: "1px solid #E2E8F0",
  color: "#1E293B",
  lineHeight: 1.4,
  letterSpacing: "-0.1px",
  backdropFilter: "blur(8px)",
};

export const TOAST_PROGRESS_STYLE = {
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  height: "3px",
  borderRadius: "0 0 12px 12px",
};
